function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__linear-gradient",
  x1: -244.48,
  y1: 529.65,
  x2: -244.48,
  y2: 452.93,
  gradientTransform: "translate(912.77)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d0dae4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e2e6f0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__linear-gradient-2",
  x1: 759.47,
  y1: 491.29,
  x2: 1220.62,
  y2: 491.29,
  gradientTransform: "matrix(-1 0 0 1 1658.34 0)",
  xlinkHref: "#webinar_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__linear-gradient-3",
  x1: -274.98,
  y1: 529.65,
  x2: -274.98,
  y2: 402.71,
  gradientTransform: "translate(912.77)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e2e7f0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__linear-gradient-4",
  x1: 447.47,
  y1: 410.86,
  x2: 682.23,
  y2: 410.86,
  gradientTransform: "matrix(-1 0 0 1 1658.34 0)",
  xlinkHref: "#webinar_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__linear-gradient-5",
  x1: 150.21,
  y1: 449.21,
  x2: 150.21,
  y2: 322.28,
  xlinkHref: "#webinar_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__linear-gradient-6",
  x1: 598.59,
  y1: 397.88,
  x2: 695.96,
  y2: 397.88,
  gradientTransform: "matrix(-1 0 0 1 1658.34 0)",
  xlinkHref: "#webinar_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__linear-gradient-7",
  x1: 598.59,
  y1: 410.86,
  x2: 695.96,
  y2: 410.86,
  gradientTransform: "matrix(-1 0 0 1 1658.34 0)",
  xlinkHref: "#webinar_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__linear-gradient-8",
  x1: 598.59,
  y1: 423.84,
  x2: 695.96,
  y2: 423.84,
  gradientTransform: "matrix(-1 0 0 1 1658.34 0)",
  xlinkHref: "#webinar_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__New_Gradient_Swatch_2",
  x1: 715.05,
  y1: 417.66,
  x2: 762.13,
  y2: 463.57,
  gradientTransform: "matrix(-1 0 0 1 1251.13 -192.99)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3a3f4c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#3d4250"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#454c5a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#515b6d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#657284"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#7d8da5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.97,
  stopColor: "#9aafcd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a1b8d7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__New_Gradient_Swatch_2-2",
  x1: 219.95,
  y1: -1780.12,
  x2: 250.15,
  y2: -1780.12,
  gradientTransform: "matrix(-.8 .6 .6 .8 2196.88 1735.99)",
  xlinkHref: "#webinar_svg__New_Gradient_Swatch_2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__New_Gradient_Swatch_2-3",
  x1: 716.31,
  y1: 407.19,
  x2: 711.02,
  y2: 467.21,
  gradientTransform: "matrix(-1 0 0 1 1658.34 0)",
  xlinkHref: "#webinar_svg__New_Gradient_Swatch_2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__New_Gradient_Swatch_2-4",
  x1: 339.29,
  y1: 416.58,
  x2: 351.66,
  y2: 362.54,
  gradientTransform: "matrix(-.99 .13 .13 .99 1227.69 -41.84)",
  xlinkHref: "#webinar_svg__New_Gradient_Swatch_2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__linear-gradient-9",
  x1: 447.47,
  y1: 491.92,
  x2: 682.23,
  y2: 491.92,
  gradientTransform: "matrix(-1 0 0 1 1658.34 0)",
  xlinkHref: "#webinar_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__linear-gradient-10",
  x1: 150.21,
  y1: 530.28,
  x2: 150.21,
  y2: 403.35,
  xlinkHref: "#webinar_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__linear-gradient-11",
  x1: 598.59,
  y1: 477.31,
  x2: 695.96,
  y2: 477.31,
  gradientTransform: "matrix(-1 0 0 1 1658.34 0)",
  xlinkHref: "#webinar_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__linear-gradient-12",
  x1: 598.59,
  y1: 490.29,
  x2: 695.96,
  y2: 490.29,
  gradientTransform: "matrix(-1 0 0 1 1658.34 0)",
  xlinkHref: "#webinar_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__linear-gradient-13",
  x1: 598.59,
  y1: 503.27,
  x2: 695.96,
  y2: 503.27,
  gradientTransform: "matrix(-1 0 0 1 1658.34 0)",
  xlinkHref: "#webinar_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__linear-gradient-14",
  x1: 910.13,
  y1: 482.87,
  x2: 910.13,
  y2: 492.36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#008cd4",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#008cd4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#008cd4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#004fd6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webinar_svg__linear-gradient-15",
  x1: 910.58,
  y1: 505.34,
  x2: 910.58,
  y2: 495.85,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#007a85"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#00bc7f"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webinar_svg__radial-gradient",
  cx: 485.32,
  cy: -100.51,
  r: 11.27,
  gradientTransform: "matrix(0 1 1 0 138 -186.99)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#25c084"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#25c084",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webinar_svg__radial-gradient-2",
  cx: 485.32,
  cy: -64.27,
  r: 11.27,
  xlinkHref: "#webinar_svg__radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webinar_svg__radial-gradient-3",
  cx: 485.32,
  cy: -28.02,
  r: 11.27,
  xlinkHref: "#webinar_svg__radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webinar_svg__radial-gradient-4",
  cx: 406.11,
  cy: 548.63,
  r: 11.27,
  gradientTransform: "matrix(0 1 1 0 138 -186.99)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffea00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffa600",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webinar_svg__radial-gradient-5",
  cx: 406.11,
  cy: 577.58,
  r: 11.27,
  xlinkHref: "#webinar_svg__radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webinar_svg__radial-gradient-6",
  cx: 406.11,
  cy: 606.52,
  r: 11.27,
  xlinkHref: "#webinar_svg__radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webinar_svg__radial-gradient-7",
  cx: 485.54,
  cy: 548.63,
  r: 11.27,
  xlinkHref: "#webinar_svg__radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webinar_svg__radial-gradient-8",
  cx: 485.54,
  cy: 577.58,
  r: 11.27,
  xlinkHref: "#webinar_svg__radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webinar_svg__radial-gradient-9",
  cx: 485.54,
  cy: 606.52,
  r: 11.27,
  xlinkHref: "#webinar_svg__radial-gradient"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "webinar_svg__clip-path",
  transform: "translate(-407.21 -192.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-1",
  d: "M883.42 510c-3 0-5.49-3.34-5.49-7.47v-16.76a2.45 2.45 0 010-.27c0-4.13 2.45-7.47 5.49-7.47h62.21v32z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "webinar_svg__AI_Shadow_3",
  x: "-20%",
  y: "-20%",
  width: "200%",
  height: "600%"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feOffset", {
  result: "offsetBlurredAlpha",
  in: "blur"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "offsetBlurredAlpha"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("style", null, ".webinar_svg__cls-1{fill:none}.webinar_svg__cls-4{isolation:isolate;opacity:.75;filter:url(#webinar_svg__AI_Shadow_3)}.webinar_svg__cls-5{fill:#758bab}.webinar_svg__cls-48,.webinar_svg__cls-7{opacity:.3}.webinar_svg__cls-49,.webinar_svg__cls-7{fill:#a0d6ed}.webinar_svg__cls-12{fill:#25c084}.webinar_svg__cls-32{fill:#3a3f4c}.webinar_svg__cls-33{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M441.93 452.93h452.73c2.36 0 4.21 3.06 4.21 6.7V523c0 3.76-1.92 6.7-4.21 6.7H441.93c-2.36 0-4.21-3.06-4.21-6.7v-63.37c0-3.63 1.85-6.7 4.21-6.7z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__linear-gradient)"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "webinar_svg__cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-5",
  d: "M420.4 523.11h463.41c2.36 0 4.21 3 4.21 6.69v-1.26c0 3.76-1.92 6.69-4.21 6.69H420.4c-2.36 0-4.21-3.05-4.21-6.69v1.26c0-3.64 1.81-6.69 4.21-6.69z",
  transform: "translate(-407.21 -192.99)"
}));

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 11.71,
  width: 451.79,
  height: 297.05,
  rx: 20.38,
  opacity: 0.3,
  fill: "#e0faff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-7",
  d: "M886.18 213.45v256.3a20.37 20.37 0 01-20.38 20.38h-15.25a20.37 20.37 0 0020.37-20.38v-256.3a20.37 20.37 0 00-20.37-20.37h15.25a20.37 20.37 0 0120.38 20.37z",
  transform: "translate(-407.21 -192.99)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M419.91 214.61v256.3a20.37 20.37 0 0020.37 20.37h15.26a20.37 20.37 0 01-20.38-20.37v-256.3a20.37 20.37 0 0120.38-20.38h-15.26a20.37 20.37 0 00-20.37 20.38z",
  transform: "translate(-407.21 -192.99)",
  opacity: 0.15,
  fill: "#a0d6ed"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M441.93 452.93h452.73c2.36 0 4.21 3.06 4.21 6.7V523c0 3.76-1.92 6.7-4.21 6.7H441.93c-2.36 0-4.21-3.06-4.21-6.7v-63.37c0-3.63 1.85-6.7 4.21-6.7z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__linear-gradient-2)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M411.42 452.93h452.73c2.36 0 4.21 3.06 4.21 6.7V523c0 3.76-1.92 6.7-4.21 6.7H411.42c-2.36 0-4.21-3.06-4.21-6.7v-63.37c0-3.63 1.85-6.7 4.21-6.7z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__linear-gradient-3)"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 37.56,
  cy: 298.29,
  r: 11.29,
  fill: "url(#webinar_svg__radial-gradient)"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "webinar_svg__cls-12",
  cx: 37.56,
  cy: 298.29,
  r: 6.56
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 73.81,
  cy: 298.29,
  r: 11.29,
  fill: "url(#webinar_svg__radial-gradient-2)"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  className: "webinar_svg__cls-12",
  cx: 73.81,
  cy: 298.29,
  r: 6.56
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 110.06,
  cy: 298.29,
  r: 11.29,
  fill: "url(#webinar_svg__radial-gradient-3)"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  className: "webinar_svg__cls-12",
  cx: 110.06,
  cy: 298.29,
  r: 6.56
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-5",
  d: "M958.8 444.68h237c2.36 0 4.21 3.05 4.21 6.69v-1.27c0 3.76-1.92 6.7-4.21 6.7h-237c-2.37 0-4.21-3.05-4.21-6.7v1.27c0-3.64 1.84-6.69 4.21-6.69z",
  transform: "translate(-407.21 -192.99)",
  opacity: 0.75
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M980.32 372.5h226.34c2.36 0 4.21 3.06 4.21 6.7v63.32c0 3.76-1.92 6.69-4.21 6.69H980.32c-2.36 0-4.21-3-4.21-6.69V379.2c0-3.64 1.89-6.7 4.21-6.7z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__linear-gradient-4)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M949.82 372.5h226.33c2.37 0 4.21 3.06 4.21 6.7v63.32c0 3.76-1.92 6.69-4.21 6.69H949.82c-2.37 0-4.21-3-4.21-6.69V379.2c0-3.64 1.84-6.7 4.21-6.7z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__linear-gradient-5)"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 686.7,
  cy: 219.08,
  r: 11.29,
  fill: "url(#webinar_svg__radial-gradient-4)"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 686.7,
  cy: 219.08,
  r: 6.56,
  fill: "#ffe600"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 715.65,
  cy: 219.08,
  r: 11.29,
  fill: "url(#webinar_svg__radial-gradient-5)"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  className: "webinar_svg__cls-12",
  cx: 715.65,
  cy: 219.08,
  r: 6.56
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 744.6,
  cy: 219.08,
  r: 11.29,
  fill: "url(#webinar_svg__radial-gradient-6)"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  className: "webinar_svg__cls-12",
  cx: 744.6,
  cy: 219.08,
  r: 6.56
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M964.24 395.2h93.65c1 0 1.86 1.35 1.86 3v-.56c0 1.65-.85 2.95-1.86 2.95h-93.65c-1 0-1.86-1.35-1.86-2.95v.56c0-1.65.82-3 1.86-3z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__linear-gradient-6)"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M964.24 408.18h93.65c1 0 1.86 1.35 1.86 3v-.56c0 1.65-.85 2.95-1.86 2.95h-93.65c-1 0-1.86-1.35-1.86-2.95v.56c0-1.65.82-3 1.86-3z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__linear-gradient-7)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M964.24 421.16h93.65c1 0 1.86 1.35 1.86 3v-.56c0 1.65-.85 2.95-1.86 2.95h-93.65c-1 0-1.86-1.35-1.86-2.95v.56c0-1.65.82-3 1.86-3z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__linear-gradient-8)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webinar_svg__New_Gradient_Swatch_2)",
  d: "M538.16 210.77v36.9l-18.61-14.96-1.37-15.63 19.98-6.31z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M941.1 429.69l-.68 2 7.69 11.9s11.21 4.69 12.2 10.11-3.39 11.3-3.39 11.3l-1.9-4.3-3.59 4-1.19-3.95-4.44 2.89 3.1-7.61s-21.12-1.76-19.43-13.59c1.47-10.26 11.63-12.75 11.63-12.75z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__New_Gradient_Swatch_2-2)"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M926 410.23c17.71-5 15.84 19.36 15.84 19.36s6.48-10.8 11.86-12 10.57 7.54 10.57 7.54l-5-.42 3.23 6.08-5.32-1.44-.46 7-5.39-5.76s-2.6 18.26-9.28 17.48-28.58-34.33-16.05-37.84z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__New_Gradient_Swatch_2-3)"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M895.35 387.49a1 1 0 01.58 0 31.33 31.33 0 0015.57.31 12.61 12.61 0 014-.42 6.63 6.63 0 012.76 1.08c1.83-5 6.16-8.62 12.87-10.92l1.36-.47c6.72-2.3 12.38-2.05 16.87.73a6.68 6.68 0 011.52-2.54 12.78 12.78 0 013.43-2.13 31.07 31.07 0 0012.1-9.79 1.09 1.09 0 01.5-.35 1 1 0 01.72 0 1 1 0 01.66 1.08c0 .41-.1 2.28-.12 2.8-.09 2.26-1.5 7.43-.36 12.62.1.5.21 1.09.28 1.7l-2.74 1.41 2.88 1a12.73 12.73 0 01-1.53 6.4l-3.94-.55 2.29 2.61a11.84 11.84 0 01-5.56 2.63A10.72 10.72 0 01961 398a6.56 6.56 0 01-1 5.11c-1.36 2.16-4 4.26-8 6.42a2.9 2.9 0 00-1.22 2.11c0 1.22-1.84 2.47-5.78 3.88l-.16.05a17.69 17.69 0 01-5.23 1.11 2.06 2.06 0 01-1.72-.63 2.87 2.87 0 00-2.26-.92c-4.72.79-8.19.69-10.61-.31a6.37 6.37 0 01-3.69-3.75v-.1a24.39 24.39 0 01-.67-3.05 13 13 0 01-2.26.9l-.62-3.1-1.14 3.28-.81-1.66-.81 1.83a9.79 9.79 0 01-5.36-2.09l2.38-4-4 2.5a14.66 14.66 0 01-2.64-3.54l1.61-1.63-2.29.42 2.36-2.34-3 1c-2.4-4-6-6.74-7.3-8.27-.32-.38-1.52-1.78-1.81-2.09a1 1 0 01-.25-.41 1 1 0 01.63-1.23z",
  transform: "translate(-407.21 -192.99)",
  fill: "#231e36"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M895.35 387.49a1 1 0 01.58 0 31.33 31.33 0 0015.57.31 12.61 12.61 0 014-.42 6.63 6.63 0 012.76 1.08c1.83-5 6.16-8.62 12.87-10.92l1.36-.47c6.72-2.3 12.38-2.05 16.87.73a6.68 6.68 0 011.52-2.54 12.78 12.78 0 013.43-2.13 31.07 31.07 0 0012.1-9.79 1.09 1.09 0 01.5-.35 1 1 0 01.72 0 1 1 0 01.66 1.08c0 .41-.1 2.28-.12 2.8-.09 2.26-1.5 7.43-.36 12.62.1.5.21 1.09.28 1.7l-2.74 1.41 2.88 1a12.73 12.73 0 01-1.53 6.4l-3.94-.55 2.29 2.61a11.84 11.84 0 01-5.56 2.63A10.72 10.72 0 01961 398a6.56 6.56 0 01-1 5.11c-1.36 2.16-4 4.26-8 6.42a2.9 2.9 0 00-1.22 2.11c0 1.22-1.84 2.47-5.78 3.88l-.16.05a17.69 17.69 0 01-5.23 1.11 2.06 2.06 0 01-1.72-.63 2.87 2.87 0 00-2.26-.92c-4.72.79-8.19.69-10.61-.31a6.37 6.37 0 01-3.69-3.75v-.1a24.39 24.39 0 01-.67-3.05 13 13 0 01-2.26.9l-.62-3.1-1.14 3.28-.81-1.66-.81 1.83a9.79 9.79 0 01-5.36-2.09l2.38-4-4 2.5a14.66 14.66 0 01-2.64-3.54l1.61-1.63-2.29.42 2.36-2.34-3 1c-2.4-4-6-6.74-7.3-8.27-.32-.38-1.52-1.78-1.81-2.09a1 1 0 01-.25-.41 1 1 0 01.63-1.23z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__New_Gradient_Swatch_2-4)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-32",
  d: "M908.45 393c4.45.29 8.08.84 9.75 3.34s2 6.66 2.32 10.28c0 .4.07.81.12 1.21a15.8 15.8 0 01-2.24 1l-.62-3.1-1.14 3.27-.81-1.66-.81 1.83a9.79 9.79 0 01-5.36-2.09l2.38-4-4 2.5a14.66 14.66 0 01-2.64-3.54l1.61-1.63-2.29.42 2.36-2.34-3 1c-2.4-4-6-6.74-7.3-8.27-.32-.38-1.52-1.78-1.81-2.09 4.51 3.38 9.03 3.59 13.48 3.87zm22.74-11.93c-.66-.18-3 1-3 1-.55.28-.79.85-.38 1a3.49 3.49 0 002.73-.39c1.12-.65 1.33-1.41.66-1.59zm.98 2.25c-1.36.54-.13 1.67.75 1.55s2-1 1.67-1.45-1.71-.38-2.42-.1zm3.43-4.04a2.84 2.84 0 00-1.84 2.22c.08.6.87.6 2.68.26s3.1-1.71 2.94-2.19-2.75-.54-3.78-.29zm18.74 4.72c.13-1.65.09-4 4-7.18l.07-.06a28.17 28.17 0 004.61-4.07 30.16 30.16 0 005.29-8.62c0 .41-.1 2.28-.12 2.8-.09 2.26-1.5 7.43-.36 12.62.1.5.21 1.09.28 1.7l-2.74 1.41 2.88 1a12.73 12.73 0 01-1.55 6.4l-3.94-.55 2.29 2.61a10.65 10.65 0 01-5.57 2.63c-.23-.35-.45-.68-.67-1-1.97-2.85-4.7-6.69-4.47-9.69zm-27.11 20.82c.67 1.51 2 2 4.93 1 .35-.12.72-.27 1.1-.43 3-1.3 4.25-2.21 7.63-3.4s4.9-1.21 8.08-2.11a11.47 11.47 0 001.12-.35c2.89-1 3.65-2.25 3.24-3.86 3 1.11 1 5-1 6.95s-4.7 3.63-8.91 5.25l-.93.32c-4.3 1.36-7.5 1.82-10.25 1.47-2.69-.34-6.75-2-5.06-4.83z",
  transform: "translate(-407.21 -192.99)"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-33",
  d: "M953.43 400.27c.5-.85 1.22-2.3.67-3.29a.07.07 0 00-.13 0 3.67 3.67 0 01-1.88 2.29.07.07 0 000 .12l1.24.88a.08.08 0 00.1 0zm-1.33 1.78a9.18 9.18 0 00.91-1.13.1.1 0 000-.15l-1.34-.95a.07.07 0 00-.11.07l.38 2.11c0 .12.11.14.19.05zm-.72.3l-.41-2.23a.22.22 0 00-.3-.17l-.38.14a10.94 10.94 0 01-1.17.36h-.1a.22.22 0 00-.06.4l2.3 1.54a.08.08 0 00.12-.07zm-3.12 2.65a18.28 18.28 0 002.53-1.72.31.31 0 000-.48l-2.73-1.8a.07.07 0 00-.11.06l-.14 3.71a.3.3 0 00.45.26zm-1.03.26l.12-4a.29.29 0 00-.35-.26l-1.16.25c-.69.15-1.35.3-2.08.49a.22.22 0 00-.1.37l3.46 3.2a.07.07 0 00.12-.05zm-3.48 1.86c.94-.37 1.8-.74 2.6-1.12a.29.29 0 00.07-.48l-3-2.79a.07.07 0 00-.12 0v4.07a.29.29 0 00.4.27zm-1.12.04a.07.07 0 00.13-.05v-4.69a.31.31 0 00-.38-.29c-.4.13-.81.26-1.26.42l-1.24.46a.3.3 0 00-.13.46l2.91 3.69zm-3.48 1.36c.86-.2 1.77-.45 2.73-.74a.3.3 0 00.15-.47l-2.52-3.19a.07.07 0 00-.13 0l-.59 4a.29.29 0 00.36.33zm-1.02-.06l.7-4.66a.22.22 0 00-.31-.23c-.68.31-1.29.61-1.92.92l-1.16.57a.22.22 0 00-.07.34l2.63 3.09a.07.07 0 00.13 0zm-4.13.71a18.64 18.64 0 003.06-.24.29.29 0 00.18-.48l-2.42-2.81a.07.07 0 00-.12 0c-.16.5-.73 2.32-1 3.12a.29.29 0 00.27.38zm-2.13-2.36l1.08 2a.07.07 0 00.13 0l.83-2.65a.22.22 0 00-.29-.27h-.09c-.41.19-.8.33-1.14.45l-.39.13a.22.22 0 00-.13.31zm-1.09 1.91a11.6 11.6 0 001.42.31c.12 0 .17 0 .11-.16l-1-1.89a.08.08 0 00-.14 0l-.46 1.58a.12.12 0 00.08.14zm-1.31-.48c.17.09.36.16.55.24a.09.09 0 00.1-.05l.42-1.47a.07.07 0 00-.08-.09 4.5 4.5 0 01-1.73 0 2.82 2.82 0 01-1.16-.58c-.06 0-.14 0-.12.07a1.27 1.27 0 00.12.36 3.77 3.77 0 001.9 1.55z",
  transform: "translate(-407.21 -192.99)"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-32",
  d: "M951 385.74c-2.31.73-4.26 4.3-8 7.53-1.36 1.18-2.9 2.28-3.12 2.44a18.4 18.4 0 002.68-.6 5.37 5.37 0 005.51.91 4.84 4.84 0 003.5-5.55 6.06 6.06 0 00-.49-1.67 14.22 14.22 0 00-4 1.93 13 13 0 014-3.19 7.12 7.12 0 012.42-.46s-1.09-1.8-2.48-1.34zm-28 11.7a12.75 12.75 0 015.11 0 14 14 0 00-4.34 1 6.28 6.28 0 00.66 1.61 4.85 4.85 0 006.21 2.14 5.38 5.38 0 003.73-4.15 19.32 19.32 0 002.46-1.21c-.28 0-2.15.11-4 .05-5-.18-8.69-1.76-11-.88-1.36.52-1.07 2.58-1.07 2.58a6.94 6.94 0 012.15-1.14z",
  transform: "translate(-407.21 -192.99)"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M928.1 397.45a13.49 13.49 0 00-4.32 1 6.07 6.07 0 00.66 1.61 4.83 4.83 0 006.19 2.14 5.36 5.36 0 003.72-4.15 32.71 32.71 0 01-6.25-.6zm14.5-2.32a5.34 5.34 0 005.49.91 4.83 4.83 0 003.5-5.54 6.42 6.42 0 00-.49-1.67 13.74 13.74 0 00-4 1.92 32.8 32.8 0 01-4.5 4.38z",
  transform: "translate(-407.21 -192.99)",
  fill: "#3fb681"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M944.64 395.12c-.46-.8 3.83-3.61 3.83-3.61 1.29-1.07 1.53-.08 1.43.5s-.37 2.59-1.74 3.3-3.16.37-3.52-.19zm-18.1 5.11c.42.41 1.89 1.69 3.42 1.5s2.77-1.44 2.64-2.35-5.25-.43-5.25-.43c-.72.05-1.87.27-.81 1.28z",
  transform: "translate(-407.21 -192.99)",
  fill: "#7bc7a7"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-33",
  d: "M946 393.41s-1.39.91-1.18 1.61 2-1.58 2.45-2-.14-.49-1.27.41zm-15.52 5.48s1.66-.16 1.93.51-2.51 0-3.17 0-.2-.46 1.24-.47z",
  transform: "translate(-407.21 -192.99)"
});

var _ref38 = /*#__PURE__*/React.createElement("g", {
  className: "webinar_svg__cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-5",
  d: "M958.8 524.22h237c2.36 0 4.21 3 4.21 6.69v-1.26c0 3.76-1.92 6.69-4.21 6.69h-237c-2.37 0-4.21-3.05-4.21-6.69v1.26c0-3.64 1.84-6.69 4.21-6.69z",
  transform: "translate(-407.21 -192.99)"
}));

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M980.32 453.57h226.34c2.36 0 4.21 3.05 4.21 6.69v63.32c0 3.76-1.92 6.7-4.21 6.7H980.32c-2.36 0-4.21-3-4.21-6.7v-63.32c0-3.64 1.89-6.69 4.21-6.69z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__linear-gradient-9)"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M949.82 453.57h226.33c2.37 0 4.21 3.05 4.21 6.69v63.32c0 3.76-1.92 6.7-4.21 6.7H949.82c-2.37 0-4.21-3-4.21-6.7v-63.32c0-3.64 1.84-6.69 4.21-6.69z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__linear-gradient-10)"
});

var _ref41 = /*#__PURE__*/React.createElement("circle", {
  cx: 686.7,
  cy: 298.51,
  r: 11.29,
  fill: "url(#webinar_svg__radial-gradient-7)"
});

var _ref42 = /*#__PURE__*/React.createElement("circle", {
  className: "webinar_svg__cls-12",
  cx: 686.7,
  cy: 298.51,
  r: 6.56
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  cx: 715.65,
  cy: 298.51,
  r: 11.29,
  fill: "url(#webinar_svg__radial-gradient-8)"
});

var _ref44 = /*#__PURE__*/React.createElement("circle", {
  className: "webinar_svg__cls-12",
  cx: 715.65,
  cy: 298.51,
  r: 6.56
});

var _ref45 = /*#__PURE__*/React.createElement("circle", {
  cx: 744.6,
  cy: 298.51,
  r: 11.29,
  fill: "url(#webinar_svg__radial-gradient-9)"
});

var _ref46 = /*#__PURE__*/React.createElement("circle", {
  className: "webinar_svg__cls-12",
  cx: 744.6,
  cy: 298.51,
  r: 6.56
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M964.24 474.64h93.65c1 0 1.86 1.34 1.86 2.95V477c0 1.66-.85 3-1.86 3h-93.65c-1 0-1.86-1.34-1.86-3v.56c0-1.56.82-2.92 1.86-2.92z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__linear-gradient-11)"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M964.24 487.62h93.65c1 0 1.86 1.34 1.86 2.95V490c0 1.66-.85 2.95-1.86 2.95h-93.65c-1 0-1.86-1.34-1.86-2.95v.56c0-1.56.82-2.94 1.86-2.94z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__linear-gradient-12)"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M964.24 500.6h93.65c1 0 1.86 1.34 1.86 2.95V503c0 1.66-.85 2.95-1.86 2.95h-93.65c-1 0-1.86-1.34-1.86-2.95v.56c0-1.62.82-2.96 1.86-2.96z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__linear-gradient-13)"
});

var _ref50 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#webinar_svg__clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M947.45 492.36h-74.64a4.75 4.75 0 010-9.49h74.64a4.75 4.75 0 010 9.49z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__linear-gradient-14)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M947.45 505.34h-73.73a4.75 4.75 0 110-9.49h73.73a4.75 4.75 0 010 9.49z",
  transform: "translate(-407.21 -192.99)",
  fill: "url(#webinar_svg__linear-gradient-15)"
}));

var _ref51 = /*#__PURE__*/React.createElement("g", {
  id: "webinar_svg__Artwork"
}, /*#__PURE__*/React.createElement("g", {
  id: "webinar_svg__b_w_mascot",
  "data-name": "b w mascot"
}, /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-1",
  d: "M693.31 387.68a18.1 18.1 0 00-11.88 10.37s-.84 4.79-26.34 5.07h-.78c-25.5-.37-26.34-5.07-26.34-5.07a18.11 18.11 0 00-11.87-10.37c-44.18-7.28-50.73-21.9-52-32.58-.77-6.15 1.2-14.71 3.15-21.41 4.38-15.11 10.48-35.81 5-48.44-3-7-11.17-17-33-25.06l-.37-.14c-4-1.39-17.87-7-26-10.8a59.58 59.58 0 01-21.57-16 63.82 63.82 0 01-9.74-15.43c43.38 29 72.87 22.49 85.4 28.82A25.85 25.85 0 01579 260c12.79-19.64 35.54-32.2 72.4-32.2h6.6c36.88 0 59.64 12.56 72.41 32.2a25.83 25.83 0 0112-13.31c12.53-6.33 42 .17 85.4-28.84A65.62 65.62 0 01810 241.27c-6.64 5.66-18.3 10.21-30.63 15-19 7.36-38.74 15.23-42.24 28.49-3.55 13.58 1.31 31.75 5.2 47.93a99.85 99.85 0 013.16 20.62c-.57 10.9-5.57 26.69-52.18 34.37z",
  transform: "translate(-407.21 -192.99)"
}), /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-7",
  d: "M832.64 217.8a4.8 4.8 0 00-4.78-4.8h-.21a4.76 4.76 0 00-2.55.84c-29 19.38-51.81 22.41-66.9 24.41-7.46 1-13.35 1.78-18 4.11a30.88 30.88 0 00-10.32 8.75C714.56 232.42 690.42 223 657.94 223h-6.59c-32.49 0-56.63 9.47-71.94 28.18a30.88 30.88 0 00-10.32-8.75H569c-4.6-2.32-10.49-3.11-17.95-4.1-15.07-2-37.88-5.06-66.9-24.45a4.8 4.8 0 00-7.05 5.95c.78 1.76 3.84 9.72 4.69 11.94 3.71 9.67 17.52 29.94 20.27 54.11.3 2.32.71 5 1.27 7.75l14 2.08-11.04 8.29a58.46 58.46 0 0016.38 25.39l16.24-8.23-6 14.7c7.24 3.19 17.07 4.52 28 3.13-1.59 6.86-2.1 12.37-1.55 16.71a30 30 0 0011.7 20.7c9.1 7.34 23.51 12.56 44 16a13.17 13.17 0 018.39 7.31c1.78 5.33 11.61 8 30.81 8.24h.9c11.11-.12 19.29-1.11 24.32-2.93 4.22-1.53 5.88-3.58 6.49-5.27a13.21 13.21 0 018.41-7.35c21.6-3.58 36.47-9.16 45.48-17.05a29 29 0 0010.41-21.73v-.47a103.84 103.84 0 00-1.65-14.15 64.89 64.89 0 0011.14.54l-1.92-14.39 9.83 12.74 1-8.39 6.24 6.71a44.92 44.92 0 0020.08-17l-16.2-13.79 21.09 4.88a65.59 65.59 0 006.21-19.3l-9.4-4.67s10.56-1.54 10.56-1.58l-13.67-6.63 14.5.14c4.4-21 15.94-38.06 19.32-46.64.83-2.11 3.93-9.94 4.74-11.74a4.75 4.75 0 00.5-2.08zM693.31 387.67A18.1 18.1 0 00681.43 398s-.84 4.79-26.34 5.07h-.78C628.81 402.74 628 398 628 398a18.11 18.11 0 00-11.87-10.37c-44.18-7.27-50.73-21.89-52-32.57-.77-6.15 1.2-14.71 3.15-21.41 4.38-15.11 10.48-35.81 5-48.44-3-7-11.17-17-33-25.06l-.37-.14c-4-1.39-17.87-7-26-10.8a59.58 59.58 0 01-21.57-16 63.82 63.82 0 01-9.74-15.43c43.38 29 72.87 22.49 85.4 28.82a25.85 25.85 0 0112 13.4c12.79-19.64 35.54-32.2 72.4-32.2h6.6c36.88 0 59.64 12.56 72.41 32.2a25.83 25.83 0 0112-13.31c12.53-6.33 42 .17 85.4-28.84A65.62 65.62 0 01810 241.27c-6.64 5.66-18.3 10.21-30.63 15-19 7.36-38.74 15.23-42.24 28.49-3.55 13.58 1.31 31.75 5.2 47.93a99.85 99.85 0 013.16 20.62c-.53 10.85-5.53 26.64-52.14 34.32z",
  transform: "translate(-407.21 -192.99)"
}), /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-7",
  d: "M663.22 238.34c2.59-1.78 14.46-.28 14.46-.28 2.79.4 4.68 2.48 3.18 3.86a16 16 0 01-12.41 2.32c-5.84-1.16-7.85-4.13-5.23-5.9zm-.91 11.2c6.68.33 3 7-1 7.81s-10.17-1.29-9.35-3.79 6.89-4.21 10.35-4.02zm-20.8-12.41c4.84-.56 10.84 4.68 11.24 6.88.51 2.73-2.9 3.9-11.24 5.1s-16-2.78-16-5.1 11.13-6.42 16-6.88z",
  transform: "translate(-407.21 -192.99)",
  id: "webinar_svg__Spots"
}), /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-7",
  d: "M617.21 332c1.7-.36 15.32-3.57 18.52-13.08.07.08 4.67 14.86-18.52 13.08zm56.58-13c3.5 10.15 18.69 13.12 18.69 13.12-24.77 1.15-18.69-13.12-18.69-13.12z",
  transform: "translate(-407.21 -192.99)",
  id: "webinar_svg__Creases"
}), /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-7",
  d: "M586.51 288.56c10.38-.32 23.37 11.37 43.12 19.15 7.2 2.83 15 5.11 16.1 5.43s-7 .87-11.68 1.39A23.1 23.1 0 01613 326c-13.81 0-20.45-8.58-22.08-17.49a25.23 25.23 0 01-.37-7.46s6-.84 19 2.11c-8-4-14.78-7-20.74-7.23a30.71 30.71 0 00-10.46 1.56s1.87-8.79 8.16-8.93zm135.7 7.37v.07c-5.93.23-12.74 3.24-20.71 7.22 12.93-2.94 19-2.1 19-2.1a26.69 26.69 0 01-.4 7.46c-1.62 8.9-8.28 17.49-22.09 17.49a23.16 23.16 0 01-21-11.5c-4.67-.54-12.82-1.08-11.68-1.4s8.88-2.59 16.1-5.42c19.82-7.79 32.73-19.5 43.13-19.15 6.26.19 8 9 8 9a30.18 30.18 0 00-10.35-1.67z",
  transform: "translate(-407.21 -192.99)",
  id: "webinar_svg__Brow_Eyes",
  "data-name": "Brow Eyes"
}), /*#__PURE__*/React.createElement("path", {
  id: "webinar_svg__Grin",
  className: "webinar_svg__cls-7",
  d: "M725.06 333c-.68 8.25-6.33 12.93-21.71 12.93-1.86 0-3.81-.07-5.92-.21-16.59-1.08-23.82-3.42-41.81-3.42s-25.22 2.39-41.77 3.42a58.36 58.36 0 01-5.91.21c-15.38 0-21-4.61-21.74-12.93-12.58 10.31 3.6 25.13 16 31.35s28.31 9.42 51 10.08h4.95c22.65-.73 38.57-3.86 51-10.08 12.16-6.16 28.53-21.03 15.91-31.35zm-131.81 22c-3.79-3.18-9.59-8.86-8.63-14.44a.37.37 0 01.44-.3.39.39 0 01.25.17c2.67 4.48 7.7 6.75 12.69 7.72a.36.36 0 01.29.43.34.34 0 01-.06.15l-4.44 6.21a.36.36 0 01-.52.07zm9.28 6.27a53.93 53.93 0 01-6.18-3.84.56.56 0 01-.13-.77l4.79-6.75a.38.38 0 01.52-.08.38.38 0 01.15.24l1.67 10.61c.1.62-.27.88-.81.59zm3.94.19l-1.78-11.26a1.11 1.11 0 01.93-1.27h2.2a61.5 61.5 0 006.15-.22h.49a1.11 1.11 0 011 1.78l-8.35 11.16a.38.38 0 01-.52.07.38.38 0 01-.15-.24zm19.19 7.39a94.61 94.61 0 01-14.88-4 1.51 1.51 0 01-.89-1.92 1.9 1.9 0 01.2-.37c2.5-3.35 8.23-11 9.79-13.17a.37.37 0 01.64.09l6.79 17.33a1.49 1.49 0 01-.85 1.93 1.51 1.51 0 01-.79.07zm5.28-.5l-7.15-18.59a1.47 1.47 0 01.84-1.91 1.24 1.24 0 01.38-.09c2-.23 4-.46 5.94-.71 3.49-.43 6.89-.85 10.67-1.17a1.11 1.11 0 011.2 1 1.07 1.07 0 01-.12.61l-11.07 20.89a.37.37 0 01-.5.16.34.34 0 01-.18-.21zm19.6 3.07q-7.57-.29-14.16-1a1.48 1.48 0 01-1.32-1.63 1.36 1.36 0 01.16-.53l9.49-18.26a.38.38 0 01.51-.15.36.36 0 01.17.21l6.61 19.32a1.47 1.47 0 01-.92 1.88 1.44 1.44 0 01-.54.07zm5.38-1.71a.37.37 0 01-.48.23.36.36 0 01-.22-.23l-7.64-22.31a1.48 1.48 0 01.92-1.88 1.25 1.25 0 01.42-.08c2.06-.08 4.26-.12 6.65-.12s4.6 0 6.65.12a1.49 1.49 0 011.43 1.54 1.42 1.42 0 01-.08.42zm18.75.71c-4.42.47-9.13.82-14.18 1a1.47 1.47 0 01-1.54-1.42 1.45 1.45 0 01.08-.54l6.62-19.32a.37.37 0 01.48-.23.34.34 0 01.2.17l9.5 18.16a1.48 1.48 0 01-.61 2 1.36 1.36 0 01-.55.09zm4.74-2l-11.06-20.88a1.12 1.12 0 01.46-1.51 1.08 1.08 0 01.61-.12c3.77.32 7.17.74 10.68 1.16 2.07.26 4.17.52 6.41.77a1.11 1.11 0 011 1.22 1.43 1.43 0 01-.07.28l-7.33 19a.37.37 0 01-.45.26.39.39 0 01-.25-.22zm20.84-3.51a93.85 93.85 0 01-14.88 4 1.49 1.49 0 01-1.73-1.2 1.47 1.47 0 01.08-.8l6.78-17.32a.37.37 0 01.48-.21.35.35 0 01.17.12c1.55 2.12 7.29 9.82 9.78 13.17a1.49 1.49 0 01-.34 2.08 1.41 1.41 0 01-.34.19zm6.09-14.68l-1.78 11.26a.37.37 0 01-.66.17l-8.36-11.17a1.11 1.11 0 01.22-1.55 1.17 1.17 0 01.74-.22h.49a61.5 61.5 0 006.15.22h2a1.11 1.11 0 011.17 1.06 1.48 1.48 0 010 .21zm8.35 7.21a52 52 0 01-6.19 3.86c-.55.29-.91 0-.82-.58l1.69-10.72a.36.36 0 01.42-.31.33.33 0 01.24.15l4.78 6.73a.56.56 0 01-.11.78zm5.43-4.42c-.7.69-1.44 1.35-2.22 2a.37.37 0 01-.52 0l-4.45-6.23a.38.38 0 01.08-.52.47.47 0 01.15-.06 22.85 22.85 0 008.14-3 14.14 14.14 0 004.56-4.67.37.37 0 01.51-.12.39.39 0 01.17.25 7.2 7.2 0 010 1.91c-.36 3.13-2.58 6.77-6.44 10.51z",
  transform: "translate(-407.21 -192.99)"
})));

var _ref52 = /*#__PURE__*/React.createElement("g", {
  className: "webinar_svg__cls-48"
}, /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-49",
  d: "M72.51 237.4L53.7 226.54v21.72l18.81-10.86z"
}));

var _ref53 = /*#__PURE__*/React.createElement("g", {
  className: "webinar_svg__cls-48"
}, /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-49",
  d: "M838.53 427.39a3 3 0 110 6H495.32a3 3 0 010-6h343.21m0-2H495.32a5 5 0 000 10h343.21a5 5 0 100-10z",
  transform: "translate(-407.21 -192.99)"
}), /*#__PURE__*/React.createElement("path", {
  className: "webinar_svg__cls-49",
  d: "M519.05 425.39a5 5 0 010 10h-23.73a5 5 0 010-10z",
  transform: "translate(-407.21 -192.99)"
}));

function SvgWebinar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 826.08 343.35"
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "webinar_svg__Layer_1",
    "data-name": "Layer 1"
  }, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, /*#__PURE__*/React.createElement("path", {
    d: "M878 501.81v-16.26a2.45 2.45 0 010-.27c0-4.13 2.45-7.47 5.49-7.47s5.49 3.34 5.49 7.47v17.07c0 4.13-2.46 7.47-5.49 7.47s-5.49-3.34-5.49-7.47v-.54z",
    transform: "translate(-407.21 -192.99)",
    style: {
      isolation: "isolate"
    },
    fill: "#758bab",
    opacity: 0.75
  }), _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, /*#__PURE__*/React.createElement("g", {
    id: "webinar_svg__Layer_2",
    "data-name": "Layer 2",
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref51), _ref52, _ref53)));
}

export default __webpack_public_path__ + "static/webinar.d3d995af.svg";
export { SvgWebinar as ReactComponent };